import { useMutation } from "react-query";
import { axiosInstance } from "../../config/axios";
import { PagingResponse } from "../_types";

export interface MerchantBalanceListRequest {
    page?: number;
    size?: number;
    orderByDesc?: boolean;
    orderBy?: string;
    merchantId?: number;
    status?: string;
    filters?: any[];
    startDate?: string;
    endDate?: string;
    merchantIds?: string;
}

export interface MerchantBalanceListItem {
    id: number;
    merchantId: number;
    description: string;
    amount: number;
    merchantCurrentBalanceType: number;
    merchantCurrentBalanceTypeId: number;
    currency: string;
}

export const useGetMerchantBalanceListByMerchant = () => {
    return useMutation<
        { isSuccess: boolean; message: string; data: PagingResponse<MerchantBalanceListItem[]> },
        Error,
        MerchantBalanceListRequest
    >({
        mutationFn: async (request: MerchantBalanceListRequest) => {
            const { data } = await axiosInstance.post(
                "/MerchantCurrentBalanceMovement/ListByMerchant",
                request
            );
            return data;
        },
    });
};
